import "bootstrap/dist/css/bootstrap.min.css";
import React from "react";
import { Badge, Col, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import ImageGallery from "react-image-gallery";
import "react-image-gallery/styles/css/image-gallery.css";
import { IMainProductImages, ProductItemData } from "../../../../business";
interface IProductHero {
    images: IMainProductImages[];
    isMobile: boolean;
    data: ProductItemData;
    details: string;
    shippingDescription: string;
}

export const ProductHero: React.FC<IProductHero> = ({ data, details, images, isMobile, shippingDescription }) => {
    const { t } = useTranslation('product');
    return (
        <Row className={`rounded bg-white p-3 ${isMobile ? "" : "mt-3 shadow"}`}>
            <Col xs={12} sm={12} md={12} lg={12} xl={7} className={"overflow-hidden"}>
                <ImageGallery items={images} showNav={false} showPlayButton={false} />
            </Col>
            <Col>
                <h5 className={`text-capitalize pt-4 ${isMobile ? "mt-4" : ""}`}> {`${data.description} - ${data.manufacturer}`}</h5>
                <Badge
                    pill
                    bg={data.condition === "PRODUCT_NEW" ? "primary" : "secondary"}
                    className="font-poppins"
                >
                    {t(data.condition ? data.condition : "")}
                </Badge>

                <h2>R$ {data.value}</h2>
                <p className="text-detail">{shippingDescription}</p>
                <p>
                    <small>{t('compatibility')} {data.compatibility}</small>
                </p>
                <p>
                    <a href="#moreinformations">{details}</a>
                </p>
            </Col>
        </Row >
    );
}
